module.exports = __webpack_public_path__ + "static/media/sketch1.e3406dab.jpg";